var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgV2NotificationCloseX(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 17.4195,
    height: 17.4193,
    viewBox: "0 0 17.4195 17.4193",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1.129 17.4193C0.84009 17.4193 0.550973 17.3088 0.331106 17.0887C-0.110321 16.6475 -0.110321 15.9341 0.331106 15.4929L15.4927 0.331133C15.9339 -0.110082 16.6473 -0.110082 17.0885 0.331133C17.5299 0.772348 17.5299 1.4857 17.0885 1.92691L1.92689 17.0887C1.82229 17.1937 1.69794 17.277 1.56099 17.3338C1.42405 17.3905 1.27723 17.4196 1.129 17.4193Z",
    fill: "url(#paint0_linear_0_4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M16.2906 17.4193C16.0017 17.4193 15.7128 17.3088 15.4927 17.0887L0.331106 1.92691C-0.110321 1.4857 -0.110321 0.772295 0.331106 0.331133C0.772321 -0.110082 1.48546 -0.110082 1.92689 0.331133L17.0885 15.4929C17.5299 15.9341 17.5299 16.6475 17.0885 17.0887C16.8684 17.3098 16.5795 17.4193 16.2906 17.4193Z",
    fill: "url(#paint1_linear_0_4)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_4",
    x1: 6.92317,
    y1: 17.4193,
    x2: 6.92317,
    y2: 0.000221637,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A04D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF00F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_0_4",
    x1: 6.92317,
    y1: 17.4193,
    x2: 6.92317,
    y2: 0.000221637,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A04D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF00F2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgV2NotificationCloseX);
export default __webpack_public_path__ + "static/media/v2_notification_close_x.482877873427814e9eee0592d059e1cc.svg";
export { ForwardRef as ReactComponent };